module.exports = __webpack_public_path__ + "static/rent-311dd68a9fc73f650614f769d611a0ff.jpg";